"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const grain_1 = require("./grain");
const grain_suppressor_1 = require("../nodes/grain-suppressor");
const torch_data_defs_1 = require("torch-data-defs");
const table_input_helper_1 = require("./table-input-helper");
const error_1 = require("../../error");
const table_input_1 = require("../nodes/table-input");
const join_1 = require("../nodes/join");
const query_helper_1 = require("./query-helper");
const join_types_1 = require("../../common/join-types");
const signature_1 = require("../signature");
class EntityHelper extends table_input_helper_1.default {
    constructor(dataset, columns, datasetRepo) {
        super(dataset, columns, datasetRepo);
        this.dataset = dataset;
        this.table = this.node;
        let dsDef = datasetRepo.datasetByName[dataset];
        let keyField = torch_data_defs_1.default.resolveKey(dsDef);
        let keyGrain = (0, grain_1.resolveGrain)(dsDef, this.datasetRepo).find(g => g.name === keyField);
        this.grainSuppressor = new grain_suppressor_1.default([keyGrain]);
    }
    addFact(dataset, columns) {
        return this.add(dataset, columns, join_types_1.JoinType.Left);
    }
    addGeo(columns) {
        let zipJoin = (this.datasetRepo.datasetByName[this.dataset].joins || []).find(join => join.startsWith('zip-geo'));
        if (!zipJoin)
            throw new error_1.default('Dataset does not join to any zip dim');
        // Get the zip info from the dataset definition
        let [zipDataset, zipFieldType] = zipJoin.split('::');
        let zipDatasetDef = this.datasetRepo.datasetByName[zipDataset];
        let zipField = torch_data_defs_1.default.resolveFieldType(zipFieldType, zipDatasetDef);
        let zipTable = new table_input_1.default(zipDatasetDef.name, columns);
        // Create the join node and hook it up
        let join = new join_1.default(join_types_1.JoinType.Left);
        this.node.connect(join, 0);
        zipTable.connect(join, 1);
        // Create the join override for the zip
        let col1 = new signature_1.ColumnSignature(zipField, this.table.id);
        let col2 = new signature_1.ColumnSignature(zipField, zipTable.id);
        join.override(col1, col2);
        // Make sure the columns are added
        if (!this.table.columns.includes(zipField))
            this.table.columns.push(zipField);
        if (!zipTable.columns.includes(zipField))
            zipTable.columns.push(zipField);
        this.node = join;
        return this;
    }
    build() {
        let node = super.build();
        node.connect(this.grainSuppressor);
        return this.grainSuppressor;
    }
    buildHelper() {
        let node = this.build();
        return new query_helper_1.default(node, this.datasetRepo);
    }
}
exports.default = EntityHelper;
